import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';

@Component({
  selector: 'app-product-price-lists',
  standalone: true,
  imports: [CommonModule, GenericCrudComponent],
  templateUrl: './product-price-list.component.html',
  styleUrl: './product-price-list.component.css'
})
export class ProductPriceListsComponent implements OnInit {
  @Input() productId!: string;
  @Output() onPriceListsChanged = new EventEmitter<void>();
  @ViewChild('priceListCrud') priceListCrud!: GenericCrudComponent;

  // GenericCRUD config
  priceListCrudConfig!: GenericCRUD<any>;

  constructor() {}

  ngOnInit(): void {
    this.initializeCrudConfig();
  }

  /**
   * Inicializar configuración del CRUD completo (tabla + formulario)
   */
  initializeCrudConfig(): void {
    this.priceListCrudConfig = {
      useModalForm: true,
      genericTable: {
        name: 'product-price-lists',
        type: 'generic',
        paginate: false,
        loadItemsSlug: `/product/${this.productId}/price-list`,
        items: { data: [] },
        columns: [
          { name: 'Concepto', key: 'concept', type: 'text', active: true, sort: false },
          {
            name: 'Tipo', key: 'source', type: 'badge', active: true, sort: false,
            labelMap: { own: 'Propia', exam: 'Examen', course: 'Curso' },
            colorMap: {
              own: 'bg-green-100 text-green-800',
              exam: 'bg-blue-100 text-blue-800',
              course: 'bg-purple-100 text-purple-800',
            },
          },
          { name: 'Origen', key: 'origin', type: 'text', active: true, sort: false },
          { name: 'Precio', key: 'price', type: 'currency', active: true, sort: false }
        ],
        actions: [
          {
            name: 'Editar',
            key: 'edit',
            icon: 'edit',
            // Las tarifas heredadas (examen/curso) son solo lectura.
            showIf: (item: any) => item.editable,
            confirmation: false,
            form: {
              successTitle: 'Precio actualizado correctamente',
              errorTitle: 'Error al actualizar precio',
              method: 'PUT',
              fields: [
                {
                  name: 'price_list_id',
                  type: 'select',
                  label: 'Tarifa',
                  validations: 'required',
                  url: '/config/price-list/listAll',
                  singleSelection: true,
                  labelKey: 'concept',
                  disabled: true
                },
                {
                  name: 'price',
                  type: 'number',
                  label: 'Precio para este producto',
                  validations: 'required|min:0.01'
                }
              ],
              name: 'product-price-list-edit',
              createButtonTitle: '',
              cols: 1,
              createApiSlug: '',
              updateApiSlug: `/product/${this.productId}/rates/{{id}}`,
              formTitle: 'Editar Precio',
              formButtonTitle: 'Guardar',
              width: 'md'
            },
            completeForm: true
          },
          {
            name: 'Eliminar',
            key: 'delete',
            icon: 'delete',
            showIf: (item: any) => item.editable,
            confirmation: true,
            questionText: '¿Estás seguro de eliminar esta tarifa del producto?',
            actionSlug: `/product/${this.productId}/rates/{{id}}`,
            method: 'DELETE',
            deleteRowOnResponse: true
          }
        ]
      },
      genericForm: {
        successTitle: 'Tarifa asignada correctamente',
        errorTitle: 'Error al asignar tarifa',
        method: 'POST',
        fields: [
          {
            name: 'price_list_id',
            type: 'select',
            label: 'Tarifa',
            validations: 'required',
            url: '/config/price-list/listAll',
            singleSelection: true,
            labelKey: 'concept'
          },
          {
            name: 'price',
            type: 'number',
            label: 'Precio para este producto',
            validations: 'required|min:0.01'
          }
        ],
        name: 'product-price-list',
        createButtonTitle: 'Agregar Tarifa',
        cols: 1,
        createApiSlug: `/product/${this.productId}/rates`,
        updateApiSlug: `/product/${this.productId}/rates`,
        formTitle: 'Agregar Tarifa',
        formButtonTitle: 'Guardar',
        width: 'md'
      }
    };
  }

  onCrudFinished(): void {
    this.onPriceListsChanged.emit();
    // Recargar la tabla
    if (this.priceListCrud?.genericTable) {
      this.priceListCrud.genericTable['loadItems']();
    }
  }
}
